import { useEffect, useState } from 'react';

/**
 * Returns `value` after `delayMs` of stability. Use for search inputs and any
 * other expensive-to-react-to user input. Generic so callers don't need to
 * narrow at the use site.
 */
export function useDebounce<T>(value: T, delayMs: number): T {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const handle = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(handle);
    }, [value, delayMs]);

    return debounced;
}
